export default __webpack_public_path__ + "static/media/me-speaking.0aefaef0.png";